<template>
  <q-dialog
    ref="theMenuDialog"
    v-cloak
    position="left"
    full-height
    @hide="
      () => {
        hide();
      }
    "
    class="--bordered-right --shadow__bottom"
  >
    <q-card dark class="menu-dialog-card column">
      <q-list class="app-menu">
        <q-item>
          <q-item-section>
            <div class="flex items-center no-wrap">
              <AppLogo color="#fff" data-nosnippet class="q-mr-sm q-ml-xs" />
              <q-space />
              <q-btn
                flat
                round
                icon="sym_r_close"
                color="text-background-very-light"
                @click="
                  () => {
                    hide();
                  }
                "
              />
            </div>
          </q-item-section>
        </q-item>

        <q-item
          to="/"
          :active="$route.path == '/'"
          @click="
            () => {
              hide();
            }
          "
        >
          <q-item-section avatar>
            <q-avatar icon="sym_r_home" />
          </q-item-section>
          <q-item-section>
            Your Dashboard
          </q-item-section>
        </q-item>

        <q-item
          to="/search"
          :active="$route.path.includes('/search')"
          @click="
            () => {
              hide();
            }
          "
        >
          <q-item-section avatar>
            <q-avatar icon="sym_r_search" />
          </q-item-section>
          <q-item-section>
            Search Vehicles
          </q-item-section>
        </q-item>

        <q-item
          to="/watchlist"
          :active="$route.path.includes('/watchlist')"
          @click="
            () => {
              hide();
            }
          "
        >
          <q-item-section avatar>
            <q-avatar icon="sym_r_star" />
          </q-item-section>
          <q-item-section>
            Your Watchlist
          </q-item-section>
        </q-item>

        <!--<q-item to="/messages" :active="$route.path.includes('/messages')" @click="() => {
        hide();
      }">
          <q-item-section avatar>
            <q-avatar icon="sym_r_forum" />
          </q-item-section>
          <q-item-section>
            Your Messages
          </q-item-section>
        </q-item>-->
      </q-list>

      <q-space />

      <q-list class="app-menu">
        <q-item
          clickable
          @click="
            () => {
              promptContactDialog();
              hide();
            }
          "
        >
          <q-item-section avatar>
            <q-avatar icon="sym_r_question_mark" />
          </q-item-section>
          <q-item-section>
            Get Help
          </q-item-section>
        </q-item>
        <!--<q-item
          clickable
          @click="
            () => {
              promptListInventoryDialog();
              hide();
            }
          "
        >
          <q-item-section avatar>
            <q-avatar icon="sym_r_add_to_queue" />
          </q-item-section>
          <q-item-section>
            List Inventory
          </q-item-section>
        </q-item>-->
      </q-list>
    </q-card>
  </q-dialog>
</template>

<script>
import AppLogo from "@/components/AppLogo.vue";
import { Dialog } from "quasar";
import ContactDialog from "@/components/ContactDialog.vue";
import ListInventoryDialog from "@/components/ListInventoryDialog.vue";

export default {
  name: "TheMenuDialog",
  components: { AppLogo },
  props: {},
  computed: {},
  methods: {
    show() {
      this.$refs.theMenuDialog.show();
    },
    hide() {
      this.$refs.theMenuDialog.hide();
    },
    promptContactDialog() {
      Dialog.create({
        component: ContactDialog
      });
    },
    promptListInventoryDialog() {
      Dialog.create({
        component: ListInventoryDialog
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-dialog-card {
  width: 80vw;
  max-width: 350px !important;
  color: #fff;
  background: color(background, very-light);
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  margin: 8px 0;
  height: calc(100% - 16px) !important;

  .app-menu {
    .q-item {
      height: 76px;
      font-size: 16px;

      &.q-router-link--active {
        font-weight: 700;
        border-left: 4px solid color(secondary);
        background: rgba(231, 23, 27, 0.22);

        > .q-focus-helper {
          background: currentColor;
          opacity: 0.1;
        }

        .q-avatar {
          color: white;
          background: color(secondary);
          box-shadow: $shadow-bottom;
          margin-left: -4px;
        }
      }
    }

    .q-item__section--avatar {
      .q-avatar {
        height: 1em;
        width: 1em;
        background: color(background, very-very-light);
        color: color(text);
      }
    }
  }
}
</style>
